export { DMS_MODULE } from '../constants';

export const NAME = 'DanVerification';
export const CRUMB_LABEL_KEY = 'RpoDanVerification';

export enum ApproveStatusEnum {
	Approved = 1,
	Rejected = 0,
}
